export { PersonalProfileForm } from './personal-profile-form';
export { personlaProfileFormI18n } from './personal-profile-form.i18n'